<script setup>
import { computed } from 'vue'
import DropDownCalendar from './DropDownCalendar.vue'
import Icon from './Icon.vue'
import InternationalLocation from './InternationalLocation.vue'
import MultiLocation from './MultiLocation.vue'

const props = defineProps({
  dateDisplayText: {
    type: String,
    required: true,
  },
  selectedDate: {
    type: Object,
    default: null,
  },
  selectedGo: {
    type: String,
    required: true,
  },
  showDatePicker: {
    type: Boolean,
    default: false,
  },
  tempDate: {
    type: Object,
    default: null,
  },
  variant: {
    type: String,
    default: 'desktop',
    validator: (value) => ['desktop', 'mobile'].includes(value),
  },
})

const emit = defineEmits([
  'dateSelected',
  'locationSelected',
  'tempDateChanged',
  'toggleDatePicker',
])

const mobileDateButtonClass = computed(() => ([
  'py-[14px] px-4 rounded-full text-lg font-semibold transition-all flex items-center gap-2 justify-between w-full border',
  props.selectedDate?.startDate || (props.tempDate?.tempStartDate && props.tempDate?.tempEndDate)
    ? 'bg-white text-[#2F3033] border-[#2F3033]'
    : 'bg-white text-gray-700 border-[#2F3033] hover:bg-gray-50',
]))
</script>

<template>
  <div v-if="variant === 'mobile'" class="mb-6 mt-6">
    <MultiLocation
      v-if="selectedGo === 'local'"
      @select="emit('locationSelected', $event)"
    />
    <InternationalLocation
      v-else-if="selectedGo === 'international'"
      @select="emit('locationSelected', $event)"
    />

    <div class="mt-4 mb-6">
      <button
        class="tripfinder-build-date-trigger"
        :class="mobileDateButtonClass"
        @click="emit('toggleDatePicker')"
      >
        <span class="truncate">{{ dateDisplayText }}</span>
        <Icon name="calendar" class="w-5 h-5 flex-shrink-0" />
      </button>

      <div
        v-if="showDatePicker"
        class="w-full bg-white border border-[#2F3033] rounded-3xl shadow-lg p-4 mt-2"
      >
        <DropDownCalendar
          :inline="true"
          @dateSelected="emit('dateSelected', $event)"
          @tempDateChanged="emit('tempDateChanged', $event)"
        />
      </div>
    </div>
  </div>

  <template v-else>
    <div class="flex-shrink-0 w-[320px]">
      <MultiLocation
        v-if="selectedGo === 'local'"
        @select="emit('locationSelected', $event)"
      />
      <InternationalLocation
        v-else-if="selectedGo === 'international'"
        @select="emit('locationSelected', $event)"
      />
    </div>

    <div class="flex-shrink-0 w-[300px]">
      <DropDownCalendar
        :externalDisplayText="dateDisplayText"
        @dateSelected="emit('dateSelected', $event)"
        @tempDateChanged="emit('tempDateChanged', $event)"
      />
    </div>
  </template>
</template>
